"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TelemetryEvent;
(function (TelemetryEvent) {
    TelemetryEvent["ValidateOmnichannelConfig"] = "ValidateOmnichannelConfig";
    TelemetryEvent["ValidateSDKConfig"] = "ValidateSDKConfig";
    TelemetryEvent["InitializeChatSDK"] = "InitializeChatSDK";
    TelemetryEvent["StartChat"] = "StartChat";
    TelemetryEvent["EndChat"] = "EndChat";
    TelemetryEvent["GetLiveChatConfig"] = "GetLiveChatConfig";
    TelemetryEvent["GetAuthToken"] = "GetAuthToken";
    TelemetryEvent["GetPreChatSurvey"] = "GetPreChatSurvey";
    TelemetryEvent["GetChatToken"] = "GetChatToken";
    TelemetryEvent["GetConversationDetails"] = "GetConversationDetails";
    TelemetryEvent["GetCurrentLiveChatContext"] = "GetCurrentLiveChatContext";
    TelemetryEvent["GetMessages"] = "GetMessages";
    TelemetryEvent["SendMessages"] = "SendMessages";
    TelemetryEvent["SendTypingEvent"] = "SendTypingEvent";
    TelemetryEvent["OnAgentEndSession"] = "OnAgentEndSession";
    TelemetryEvent["OnNewMessage"] = "OnNewMessage";
    TelemetryEvent["OnTypingEvent"] = "OnTypingEvent";
    TelemetryEvent["UploadFileAttachment"] = "UploadFileAttachment";
    TelemetryEvent["DownloadFileAttachment"] = "DownloadFileAttachment";
    TelemetryEvent["EmailLiveChatTranscript"] = "EmailLiveChatTranscript";
    TelemetryEvent["GetLiveChatTranscript"] = "GetLiveChatTranscript";
    TelemetryEvent["CreateIC3Adapter"] = "CreateChatAdapter";
    TelemetryEvent["CreateACSAdapter"] = "CreateACSAdapter";
    TelemetryEvent["CreateDirectLine"] = "CreateDirectLine";
    TelemetryEvent["GetVoiceVideoCalling"] = "GetVoiceVideoCalling";
    TelemetryEvent["GetIC3Client"] = "GetIC3Client";
    TelemetryEvent["InitializeVoiceVideoCallingSDK"] = "InitializeVoiceVideoCallingSDK";
    TelemetryEvent["AcceptVoiceCall"] = "AcceptVoiceCall";
    TelemetryEvent["AcceptVideoCall"] = "AcceptVideoCall";
    TelemetryEvent["RejectCall"] = "RejectCall";
    TelemetryEvent["StopCall"] = "StopCall";
    TelemetryEvent["OnCallDisconnected"] = "OnCallDisconnected";
    TelemetryEvent["UpdateChatToken"] = "UpdateChatToken";
    TelemetryEvent["GetChatReconnectContext"] = "GetChatReconnectContext";
    TelemetryEvent["GetPostChatSurveyContext"] = "GetPostChatSurveyContext";
    TelemetryEvent["GetAgentAvailability"] = "GetAgentAvailability";
    TelemetryEvent["GetGeolocation"] = "GetGeolocation";
})(TelemetryEvent || (TelemetryEvent = {}));
exports.default = TelemetryEvent;
//# sourceMappingURL=TelemetryEvent.js.map